module.exports = __webpack_public_path__ + "img/4.67246415.jpg";